import React from 'react';

const stepsData = [
  {
    number: "1",
    title: "Consultation",
    description: "Schedule a meeting to discuss your specific charging needs",
  },
  {
    number: "2",
    title: "Custom Solution",
    description: "Receive a tailored solution & seamless installation",
  },
  {
    number: "3",
    title: "Continued Support",
    description: "Enjoy ongoing maintenance & support, with unmatched uptime",
  },
];

const StepsSection = ({ steps = stepsData, bgImage }) => {
  return (
    <div
      className="max-w-5xl mx-auto px-4 py-12 space-y-8 blade-margin-top-sm "
    >
      <div className="text-center">
        <h3 className="text-center font-gilroy">
          Simplify your EV charging <br /> <b> with us in 3 steps</b>
        </h3>
      </div>
      <div className="bg-grey rounded-3xl p-10 flex flex-col space-y-10 md:hidden">
        {steps.map((step, index) => (
          <div
            key={step.number}
            className={`flex items-start space-x-4 ${index % 2 === 1 ? 'ml-8 md:ml-16' : ''
              }`}
          >
            <h3 className="text-7xl font-bold text-black leading-none font-poppins">{step.number}</h3>
            <div className="pt-1">
              <h3 className="text-3xl font-bold text-black font-gilroy">{step.title}</h3>
              <p className="text-gray-800 text-lg mt-1 font-poppins">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="rounded-3xl p-10 hidden flex-col space-y-10 relative min-h-[350px] md:flex">
        {/* Dashed staircase lines */}
        <div className="absolute top-5 left-5  pointer-events-none">
          {stepsData.map((_, index) => (
            <div
              key={index}
              className="absolute border-dashed border-lighyGray "
              style={{
                left: `${index * 100}px`,
                top: `${index * 100}px`,
                borderLeftWidth: 2,
                borderBottomWidth: 2,
                width: 100,
                height: 100,
              }}
            />
          ))}
        </div>

        {/* Step Texts */}
        {stepsData.map((step, index) => (
          <div
            key={step.number}
            className="absolute flex items-center"
            style={{
              left: `${index * 100 + 50}px`,
              top: `${index * 100 + 0}px`,
            }}
          >
            <h3 className='text-7xl font-bold text-black leading-none font-poppins'>{step.number}</h3>
            <div className='ml-3'>
              <h3 className="text-3xl font-bold text-black font-gilroy"> {step.title}</h3>
              <p className="text-gray-800 text-lg mt-1 font-poppinss">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepsSection;
